import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Refresh } from "@mui/icons-material";

const AccountLinkModal = ({
    open,
    usersInfo,
    steamName,
    hasAccountConnection,
    onConfirm,
    onCancel,
    onRefresh,
    onClose,
}) => (
    <Modal open={open} onClose={onClose}>
        <Paper sx={{ padding: 3, maxWidth: 400, margin: "auto", mt: "20vh" }}>
            <Typography variant="h6">Свяжите аккаунт с игрой</Typography>
            <Typography variant="body2">
                Введите в игре команду: <strong>/connect {usersInfo?.login}</strong>
            </Typography>
            <Typography variant="body2">Затем подтвердите привязку {steamName} в этом окне.</Typography>

            {hasAccountConnection && (
                <Box sx={{ display: "flex", gap: 2, mt: 2, mb: 2 }}>
                    <Button variant="contained" color="primary" onClick={onConfirm}>
                        Подтвердить
                    </Button>
                    <Button variant="contained" color="error" onClick={onCancel}>
                        Отменить
                    </Button>
                </Box>
            )}

            {!hasAccountConnection && (
                <Box sx={{ display: "flex", gap: 2, mt: 2, mb: 2 }}>
                    <Typography variant="body2" style={{ lineHeight: "50px" }}>
                        Нажмите обновить, если ввели команду:
                    </Typography>
                    <IconButton onClick={onRefresh}>
                        <Refresh color="primary" fontSize="large" title="Обновить" style={{ cursor: "pointer" }} />
                    </IconButton>
                </Box>
            )}

            <Button variant="contained" fullWidth onClick={onClose}>
                Закрыть
            </Button>
        </Paper>
    </Modal>
);

export default AccountLinkModal;
